import { render, staticRenderFns } from "./addCollectDialog.vue?vue&type=template&id=5a45764e&scoped=true"
import script from "./addCollectDialog.vue?vue&type=script&lang=js"
export * from "./addCollectDialog.vue?vue&type=script&lang=js"
import style0 from "./addCollectDialog.vue?vue&type=style&index=0&id=5a45764e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45764e",
  null
  
)

export default component.exports